export const LOCALES = {
	ENGLISH: 'en-GB',
	FRENCH: 'fr-FR',
	SPANISH: 'es-ES',
	ARABIC: 'ar-SA',
	GERMAN: 'de-DE',
	DUTCH: 'nl-NL',
}
